import { DEV_PHONE_IDENTITY } from '../config';
import {
  REQUEST_CHANNEL_DATA,
  REQUEST_CHANNEL_DATA_SUCCESS,
  REQUEST_CHANNEL_DATA_ERROR,
} from './types';

export function channelDataRequest() {
  return {
    type: REQUEST_CHANNEL_DATA,
  };
}

export function channelDataRequestSuccess(payload) {
  return {
    type: REQUEST_CHANNEL_DATA_SUCCESS,
    payload,
  };
}

export function channelDataRequestFailure(error) {
  return {
    type: REQUEST_CHANNEL_DATA_ERROR,
    error,
  };
}

export function fetchChannelData() {
  return async function (dispatch) {
    dispatch(channelDataRequest());
    const staticChannelData = {
      devPhoneName: DEV_PHONE_IDENTITY,
      phoneNumber: "+19714598531",
      conversation: null,
      forceMode: false,
    };
    dispatch(channelDataRequestSuccess(staticChannelData));
  };
}
